import { BaseMessage } from "@sendbird/chat/message"
import dayjs from "dayjs"

export const formatDate = (
  date: Date,
  format: string = "MMMM D, YYYY",
  relative = true
) => {
  const today = new Date()
  const yesterday = new Date(today)
  const tomorrow = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  tomorrow.setDate(tomorrow.getDate() + 1)
  if (relative) {
    if (date.toDateString() === today.toDateString()) {
      return "Today"
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday"
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return "Tomorrow"
    }
  }

  return dayjs(date).format(format)
}

export const getRelativeDateTime = (date: Date) => {
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  if (date.toDateString() === today.toDateString()) {
    return dayjs(date).format("h:mm a")
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Yesterday"
  }

  return dayjs(date).format("MMM D")
}

export const areMessagesInSameMinute = (
  message1: BaseMessage,
  message2: BaseMessage
) => {
  return (
    new Date(message1.createdAt).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }) ===
    new Date(message2.createdAt).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })
  )
}

export const getCurrentAge = (birthdate: string) => {
  return dayjs().diff(dayjs(birthdate), "year")
}
